module.exports = __webpack_public_path__ + "img/ST.43f8786b.svg";